export default __webpack_public_path__ + "src/images/packages/gocheganas-lodge/fff9a71139a994328a4d20cfcd1325d1-1.jpeg";